@if (isLoading$ | async) {
<div
  class="loader-wrapper"
  [class.overlay]="overlay"
  aria-hidden="false"
  role="status"
  aria-live="polite"
  aria-label="Loading content"
>
  @if (overlay) {
  <div class="loader-backdrop"></div>
  }
  <div class="spinner-container">
    <div class="mat-spinner">
      <svg class="circular" viewBox="25 25 50 50">
        <circle
          class="path"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
        />
      </svg>
    </div>
  </div>
</div>
}
